import { Story } from 'inkjs'
import { toast } from 'react-toastify'
import returnLevelObject from '../../scripts/calculateLevel'
import addHatFunction from './hatsActions';
import addAchievFunction from './achievsActions';

function GameOverError(reason = "", ...rest) {
    var instance = new Error(`Game Over, ${reason}`, ...rest);
    instance.reason = reason;
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    if (Error.captureStackTrace) {
        Error.captureStackTrace(instance, GameOverError);
    }
    return instance;
}

GameOverError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: Error,
        enumerable: false,
        writable: true,
        configurable: true
    }
});

if (Object.setPrototypeOf) {
    Object.setPrototypeOf(GameOverError, Error);
} else {
    GameOverError.__proto__ = Error;
}

const getGlobalVars = variablesState => {
    let returnArray = []
    const getValues = [...variablesState._globalVariables.entries()]

    for (let i of getValues) {
        returnArray.push({
            [i[0]]: i[1].value
        })
    }

    return returnArray
}

const getTags = tags => {
    return tags.reduce(
        (acc, tag) => ({ ...acc, [tag.split(": ")[0]]: tag.split(": ")[1] }),
        {}
    );
}

const gameLoop = (narrative) => {
    const sceneText = []
    let currentTags = []

    while (narrative.canContinue) {
        sceneText.push(narrative.Continue());
        currentTags = currentTags.concat(narrative.currentTags);
    }

    const { currentChoices, variablesState } = narrative;

    if (!narrative.canContinue && !currentChoices.length) {
        throw new GameOverError("no more choices")
    }

    const tags = getTags(currentTags);
    const checkMinigame = Object.keys(tags).find(item => item === 'minigame')

    return {
        globals: getGlobalVars(variablesState),
        currentTags: getTags(currentTags),
        currentChoices,
        sceneText,
        isInMinigame: checkMinigame ? true : false,
        minigames: checkMinigame ? tags.minigame : null,
        isAdvanceButtonLocked: checkMinigame ? true : false,
    }
}

const makeNarrative = (narrative, name) => {
    return (dispatch) => {
        dispatch({ type: 'MAKING_NARRATIVE' })
        const ink = new Story(narrative);
        dispatch({
            type: 'CREATE_NARRATIVE_SUCCESS',
            narrative: ink,
            chapter: name,
            payload: {
                ...gameLoop(ink)
            }
        })
    }
}

const makeChoice = (narrative, narrativeName, choiceIdx, choiceContent) => {
    return async (dispatch, getState, { getFirestore }) => {

        if (choiceContent !== 'Avançar' && choiceContent !== 'Voltar' && choiceContent !== 'Concluir dia de aventura' && choiceContent !== 'Começar Aventura!') {
            let db = getFirestore();
            let getCountryName = getState().game.currentNarrativeObject.country
            const getChapter = getState().game.chapter
            const getChoiceName = getState().game.currentTags.choice

            const choicesArray = []
            narrative._state._currentChoices.forEach((item, index) => {
                choicesArray.push({ choice: item.text, number: choiceIdx === item.index ? 1 : 0 })
            })

            // Add value of choices to db to calculate percentages
            try {
                const countryDocument = await db.collection("countries").doc(getCountryName).get()
                const getCountryDocument = countryDocument.data()
                const checkChoices = getCountryDocument.narrativeChoices[getChapter]?.[getChoiceName]

                if (checkChoices) {
                    // has choices on db
                    getCountryDocument.narrativeChoices[getChapter][getChoiceName][choiceIdx].number += 1

                    await db.collection("countries").doc(getCountryName).update({
                        narrativeChoices: {
                            [getChapter]: {
                                ...getCountryDocument.narrativeChoices[getChapter],
                                [getChoiceName]: getCountryDocument.narrativeChoices[getChapter][getChoiceName]

                            }
                        }
                    })
                } else {
                    // still no choices on db
                    await db.collection("countries").doc(getCountryName).update({
                        narrativeChoices: {
                            [getChapter]: {
                                ...getCountryDocument.narrativeChoices[getChapter],
                                [getChoiceName]: [...choicesArray]
                            }
                        }
                    })
                }

            } catch (err) {
                console.log(err)
                await dispatch({ type: 'UPDATE_CHOICES_NUMBER', payload: err })
            }
        }

        narrative.ChooseChoiceIndex(choiceIdx)

        try {
            const currentChoiceName = getState().game.currentTags.choice
            const gameData = gameLoop(narrative)
            if (choiceContent !== 'Avançar' && choiceContent !== 'Voltar' && choiceContent !== 'Concluir dia de aventura' && choiceContent !== 'Começar Aventura!') {
                await dispatch({ type: 'MAKE_CHOICE', payload: { ...gameData }, choice: choiceContent, choiceName: currentChoiceName })
            } else {
                // track minigame and add it to check all the minigames the player played
                let minigameName
                if (gameData.currentTags?.minigame) {
                    minigameName = gameData.currentTags.minigame
                }

                await dispatch({ type: 'MAKE_CHOICE', payload: { ...gameData }, minigame: minigameName })
            }
        } catch (err) {
            let db = getFirestore();
            const userUid = getState().firebase.auth.uid
            const userData = getState().firebase.profile

            if (err instanceof GameOverError && err.reason === "no more choices") {
                dispatch({ type: 'LOADING_UPDATE_DB_AFTER_END' })
                // check if narrative is initial cutscene
                if (narrativeName === 'cutscene-inicial') {
                    try {
                        await db.collection("users").doc(userUid).update({
                            ...userData,
                            travels: {
                                ...userData.travels,
                                completedTravels: userData.travels.completedTravels.concat('initial-cutscene')
                            }
                        })
                        await dispatch({ type: 'QUIT_GAME' })
                    } catch (err) {
                        await dispatch({ type: 'QUIT_GAME', payload: err.message })
                    }
                } else {
                    try {
                        // game state
                        const currentNarrativeCountry = getState().game.currentNarrativeObject.country
                        let updateTravelDestinies = userData.travels.completedTravels
                        let getCountryName = getState().game.currentNarrativeObject.country
                        let currentLvl = userData.level
                        let currentExp = userData.experience
                        let currentStatute = userData.statute

                        // get available items from db
                        const getItems = await db.collection('items').doc('bag').get()
                        const allItems = getItems.data()

                        const country = await db.collection('countries').doc(`${currentNarrativeCountry}`).get()
                        const countryData = country.data()

                        // add travel to user travelled places
                        if (!updateTravelDestinies.find(element => element === `${getCountryName} ${narrativeName}`)) {
                            updateTravelDestinies = [...updateTravelDestinies, `${getCountryName} ${narrativeName}`]
                        }

                        let numberOfRandomItems, numberOfExp
                        let receivedItems = []

                        switch (currentNarrativeCountry) {
                            case 'Grécia':
                                numberOfRandomItems = 2
                                numberOfExp = 50
                                break;
                            case 'Sri Lanka':
                                numberOfRandomItems = 2
                                numberOfExp = 75
                                break;
                            case 'Brasil':
                                numberOfRandomItems = 3
                                numberOfExp = 90
                                break;
                            case 'China':
                                numberOfRandomItems = 3
                                numberOfExp = 100
                                break;
                            default:
                                break;
                        }

                        for (let i = 0; i < numberOfRandomItems; i++) {
                            let min = Math.ceil(0);
                            let max = Math.floor(allItems.items.length - 1);
                            const drop = Math.floor(Math.random() * (max - min)) + min;
                            receivedItems.push(allItems.items[drop])
                        }

                        const updateExperience = currentExp += numberOfExp
                        const getLevel = currentLvl === 10 ? null : returnLevelObject(updateExperience, currentLvl)
                        const getLevelProps = getLevel ? Object.keys(getLevel).length : null

                        if (getLevelProps && getLevelProps !== 2) {
                            toast.success(getLevel.lvlMessage)
                        }

                        await db.collection("users").doc(userUid).update({
                            experience: updateExperience,
                            experiencePercentage: !getLevel && currentLvl === 10 ? 100 : getLevel.lvlPercentage,
                            level: !getLevel ? currentLvl : getLevel.level,
                            statute: getLevelProps?.statute ? getLevelProps.statute : currentStatute,
                            inventory: {
                                hats: userData.inventory.hats,
                                bag: userData.inventory.bag.concat(receivedItems)
                            },
                            travels: {
                                ...userData.travels,
                                completedTravels: updateTravelDestinies
                            }
                        })

                        dispatch(addHatFunction())
                        dispatch(addAchievFunction(['narrative', 'achievements', 'inventory-hats', 'inventory-bag']))

                        dispatch({
                            type: 'UPDATE_DB_AFTER_END_SUCCESS',
                            choices: countryData.narrativeChoices,
                            rewards: { items: receivedItems, exp: numberOfExp },
                        })
                    } catch (err) {
                        dispatch({ type: 'UPDATE_DB_AFTER_END_ERROR', payload: err.message })
                    }
                }
            } else {
                dispatch({ type: 'ERROR', payload: err.message })
            }
        }
    }
};

const checkItem = (item, narrative) => {
    return async (dispatch, getState, { getFirestore }) => {
        dispatch({ type: 'MAKING_NARRATIVE' })
        const userInventory = getState().firebase.profile.inventory
        const currentUid = getState().firebase.auth.uid

        let checkExistence = []

        if (typeof item === 'string') {
            checkExistence.push(userInventory.bag.find(element => item === element.name && item))
        } else {
            for (let i of item) {
                checkExistence.push(userInventory.bag.find(element => i === element.name && i))
            }
        }

        console.log(checkExistence)

        if (checkExistence[0]) {
            const db = getFirestore()
            const updateBag = userInventory.bag.splice(userInventory.bag.findIndex(bagItem => bagItem.name === item), 1)

            try {
                await db.collection("users").doc(currentUid).update({
                    inventory: {
                        bag: [...updateBag],
                        hats: [...userInventory.hats],
                    }
                })

                narrative.ChooseChoiceIndex(0)
                let gameData = gameLoop(narrative)
                dispatch({ type: 'MAKE_CHOICE_ITEM_SUCCESS', payload: { ...gameData }, item: item })
            } catch (err) {
                narrative.ChooseChoiceIndex(1)
                dispatch({ type: 'MAKE_CHOICE_ITEM_ERROR', payload: { ...gameLoop(narrative) }, error: err, item: item })
            }
        } else {
            narrative.ChooseChoiceIndex(1)
            dispatch({ type: 'MAKE_CHOICE_ITEM_ERROR', payload: { ...gameLoop(narrative) }, item: item })
        }
    }
}

const takePhoto = (photo, caption) => {
    return async (dispatch, getState, { getFirestore }) => {
        const db = getFirestore()
        const userUid = getState().firebase.auth.uid
        const currentTravelBook = getState().firebase.profile.travelBook
        const narrative = getState().game.currentNarrativeObject
        const currentChapter = getState().game.chapter
        const checkIfUserHasPhoto = currentTravelBook.find((item) => item.photo === photo)

        if (checkIfUserHasPhoto) {
            dispatch({ type: 'TAKE_PHOTO_SUCCESS' })
        } else {
            try {
                await db.collection("users").doc(userUid).update({
                    travelBook: currentTravelBook.concat({
                        caption: caption,
                        photo: photo,
                        country: narrative.country,
                        chapter: currentChapter,
                        tookAt: db.Timestamp.fromDate(new Date())
                    })
                })
                dispatch({ type: 'TAKE_PHOTO_SUCCESS' })
            } catch (err) {
                dispatch({ type: 'TAKE_PHOTO_ERROR', payload: err })
            }
        }
    }
}

const getNarrativeObject = (narrativeObject) => {
    return {
        type: 'GET_NARRATIVE_OBJECT',
        payload: narrativeObject
    }
}

const unlockAdvancedNarrative = (minigameName) => {
    return {
        type: 'UNLOCK_ADVANCE_BUTTON',
        payload: minigameName
    }
}

const finishMiniGame = () => {
    return {
        type: 'MINIGAME_FINISHED',
    }
}

const quitGame = () => {
    document.body.style.backgroundImage = `none`;
    return {
        type: 'QUIT_GAME'
    }
}

export default {
    makeNarrative,
    getNarrativeObject,
    makeChoice,
    checkItem,
    takePhoto,
    finishMiniGame,
    unlockAdvancedNarrative,
    quitGame
}